import { OBJECTIVE_DETAILS_PANEL_CLOSE, OBJECTIVE_DETAILS_PANEL_OPEN } from 'actions/actionTypes';

import { getObjectiveDetailsRoute, getRouteAfterRemovingObjectiveDetailsAndKRDetails } from 'constants/helper';

export const openObjectiveDetailsPanelActionCreator =
  ({
    objectivePId,
    objectiveId,
    objectiveTimeBoundId,
    timeBoundId,
    onDelete,
    onNameChange,
    onLevelChange,
    onDepartmentChange,
    onKeyResultCreation,
    onObjectiveCreation,
    // onUpdate,
    onReAlign,
    pushToHistory = true, // sometimes we only to need to push empty stack item without modifying history.
    history,
  }) =>
  (dispatch, getState) => {
    const latestCallbackInfo = getState().objectiveDetailsPanel.callbackInfo.slice(-1)?.[0];

    /* do not dispatch or push to history if same objective is already open */
    if (latestCallbackInfo) {
      const isObjectivePIdSame = Boolean(objectivePId) && objectivePId === latestCallbackInfo.objectivePId;
      const isObjectiveTimeBoundIdSame =
        Boolean(objectiveTimeBoundId) && objectiveTimeBoundId === latestCallbackInfo.objectiveTimeBoundId;
      const isTimeBoundIdSame = Boolean(timeBoundId) && timeBoundId === latestCallbackInfo.timeBoundId;
      const isObjectiveIdSame = Boolean(objectiveId) && objectiveId === latestCallbackInfo.objectiveId;

      if (isObjectivePIdSame || isObjectiveTimeBoundIdSame || (isTimeBoundIdSame && isObjectiveIdSame)) return;
    }

    const route = getObjectiveDetailsRoute({
      location: history.location,
      objectiveId,
      timeBoundId,
      objectiveTimeBoundId,
      objectivePId,
    });

    dispatch({
      type: OBJECTIVE_DETAILS_PANEL_OPEN,
      payload: {
        objectiveId,
        objectiveTimeBoundId,
        timeBoundId,
        objectivePId,
        onDelete,
        onNameChange,
        onLevelChange,
        onDepartmentChange,
        onKeyResultCreation,
        onObjectiveCreation,
        // onUpdate,
        onReAlign,
      },
    });

    if (pushToHistory) history.replace(route);
  };

export const closeObjectiveDetailsPanelActionCreator =
  ({ pushToHistory = true, history }) =>
  (dispatch) => {
    const route = getRouteAfterRemovingObjectiveDetailsAndKRDetails({
      location: history.location,
    });
    dispatch({ type: OBJECTIVE_DETAILS_PANEL_CLOSE });
    if (pushToHistory) history.replace(route);
  };
